import { render, staticRenderFns } from "./Biopsy_EachID.vue?vue&type=template&id=fcb15356&scoped=true"
import script from "./Biopsy_EachID.vue?vue&type=script&lang=js"
export * from "./Biopsy_EachID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb15356",
  null
  
)

export default component.exports